import * as React from "react";
import { SVGProps, memo } from "react";

const SvgPillPinLg = (props: SVGProps<SVGSVGElement>) => (
  <svg width={60} height={70} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#PillPinLg_svg__a)">
      <mask id="PillPinLg_svg__b" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.692 0A3.692 3.692 0 0 0 4 3.692v44.616A3.692 3.692 0 0 0 7.692 52h16.534L30 62l5.774-10h16.534A3.692 3.692 0 0 0 56 48.308V3.692A3.692 3.692 0 0 0 52.308 0H7.692Z"
        />
      </mask>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.692 0A3.692 3.692 0 0 0 4 3.692v44.616A3.692 3.692 0 0 0 7.692 52h16.534L30 62l5.774-10h16.534A3.692 3.692 0 0 0 56 48.308V3.692A3.692 3.692 0 0 0 52.308 0H7.692Z"
        fill="#26734C"
      />

      <path
        d="m24.226 52 .4-.23-.133-.232h-.267V52ZM30 62l-.4.231.4.692.4-.692-.4-.23Zm5.774-10v-.462h-.267l-.133.231.4.231ZM4.462 3.692a3.23 3.23 0 0 1 3.23-3.23v-.924a4.154 4.154 0 0 0-4.154 4.154h.924Zm0 44.616V3.692h-.924v44.616h.924Zm3.23 3.23a3.23 3.23 0 0 1-3.23-3.23h-.924a4.154 4.154 0 0 0 4.154 4.154v-.924Zm16.534 0H7.692v.924h16.534v-.924ZM30.4 61.77l-5.774-10-.8.46L29.6 62.232l.8-.462Zm4.974-10-5.774 10 .8.461 5.773-10-.799-.462Zm16.934-.232H35.774v.924h16.534v-.924Zm3.23-3.23a3.23 3.23 0 0 1-3.23 3.23v.924a4.154 4.154 0 0 0 4.154-4.154h-.924Zm0-44.616v44.616h.924V3.692h-.924Zm-3.23-3.23a3.23 3.23 0 0 1 3.23 3.23h.924a4.154 4.154 0 0 0-4.154-4.154v.924Zm-44.616 0h44.616v-.924H7.692v.924Z"
        fill="#194D33"
        mask="url(#PillPinLg_svg__b)"
      />
    </g>

    <path
      d="M25.5 38c-2.09 0-3.862-.728-5.317-2.183C18.727 34.36 18 32.589 18 30.5a7.447 7.447 0 0 1 2.2-5.3l9-9a7.446 7.446 0 0 1 5.3-2.2c2.088 0 3.86.728 5.316 2.183C41.272 17.64 42 19.411 42 21.5a7.446 7.446 0 0 1-2.2 5.3l-9 9a7.446 7.446 0 0 1-5.3 2.2Zm0-2a5.57 5.57 0 0 0 2.1-.417 5.339 5.339 0 0 0 1.8-1.183l4.433-4.467-7.767-7.766L21.6 26.6a5.383 5.383 0 0 0-1.184 1.783A5.53 5.53 0 0 0 20 30.5c0 1.533.533 2.833 1.6 3.9 1.066 1.067 2.366 1.6 3.9 1.6Z"
      fill="#fff"
    />

    <defs>
      <filter
        id="PillPinLg_svg__a"
        x={0.308}
        y={0}
        width={59.385}
        height={69.385}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />

        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />

        <feOffset dy={3.692} />

        <feGaussianBlur stdDeviation={1.846} />

        <feComposite in2="hardAlpha" operator="out" />

        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />

        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_24522_56924" />

        <feBlend in="SourceGraphic" in2="effect1_dropShadow_24522_56924" result="shape" />
      </filter>
    </defs>
  </svg>
);

const Memo = memo(SvgPillPinLg);

export default Memo;
